import { Menu, MenuClassification } from 'features/MenuList/models/menu';
import moment from 'moment';
import axiosClient from 'utils/axiosClient';

export interface MenuResponse {
  status: string;
  message: string;
  data: Menu[];
}

export interface ClassificationResponse {
  status: string;
  message: string;
  data: MenuClassification[];
}

const service = {
  getMenus(
    name: string,
    menu_code: string,
    menu_classification: string | number,
    dataDate: Date,
    menu_type?: number
  ): Promise<MenuResponse> {
    const date = moment(dataDate).format('YYYY-MM-DD');
    let url = `menus-modal?name=${name}&menu_code=${menu_code}&menu_classification=${menu_classification}&date=${date}`;
    // if (menu_type) {
    //   url += `&type=${menu_type}`;
    // }
    return axiosClient.get(url);
  },
  getMenuDetail(id: string | number): Promise<MenuResponse> {
    const url = `genres?name=${id}`;
    return axiosClient.get(url);
  },
  getClassification(): Promise<ClassificationResponse> {
    const url = `menu-classification`;
    return axiosClient.get(url);
  },
  checkMenuSub(menuIds: number[], dataDate: Date): Promise<MenuResponse> {
    const date = moment(dataDate).format('YYYY-MM-DD');
    const url = `check-menu-sub`;
    return axiosClient.post(url, { menu_ids: menuIds, data_date: date });
  },
};

export default service;
